import { useEffect, useState } from "react";
import { useSubscriber } from "../../../../hooks";
import useReferralRedemptions from "./useReferralRedemptions";
import { ReferralService } from "../../../../services";
import { useHistory } from "react-router-dom";

const useReferrals = () => {
  const { userDetails } = useSubscriber();
  const { redemptions, referralsRewardItems } = useReferralRedemptions();
  const [isLoading, setLoading] = useState(false);
  const [referralData, setReferralData] = useState();
  const [pointsEarned, setPointsEarned] = useState([]);
  const [referralPoints, setReferralPoints] = useState();
  const [receivedData, setReceivedData] = useState();
  const [pointsData, setPointsData] = useState([]);

  const [isOn, toggleSwitchState] = useState(true);
  const history = useHistory();
  const token = JSON.parse(localStorage.getItem("token"));

  const getReferrals = () => {
    setLoading(true);
    ReferralService.getReferrals(token)
      .then(({ data }) => {
        const {
          referrals,
          totalDataReward,
          pointsData,
          totalPointsRemaining: totalPoints,
        } = data;
        setReferralPoints(totalPoints ?? 0)
        setPointsData(pointsData ?? [])
        setPointsEarned(totalPoints)
        setReceivedData(totalDataReward + 'MB');
        setReferralData(referrals);
      })
      .catch(e => console.log(e))
      .finally(() => setLoading(false))
  }
  useEffect(() => {
    getReferrals();
  }, [])

  return {
    isLoading,
    referralData,
    referralPoints,
    receivedData,
    isOn,
    toggleSwitchState,
    history,
    redemptions,
    referralsRewardItems,
    pointsEarned,
    pointsData,
  }
}

export default useReferrals;